import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
}                     from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import {
  Alert,
  AlertTitle,
} from '@material-ui/lab';

import {
  stopExecution,
}                     from  '../hooks';

const useStyles = makeStyles((theme) => ({
  root: {
  },
}));

export default function ExecutionActionStop(props) {
  const { execution, open, onClose } = props;

  const [stopExecutionStatus, setStopExecutionStatus] = React.useState(null);
  const [stopExecutionMessage, setStopExecutionMessage] = React.useState(null);

  const classes = useStyles();


  const handleClose = () => {
    setStopExecutionStatus(null);
    setStopExecutionMessage(null);
    if(onClose) {
      onClose();
    }
  };

  const handleStopExecution = async () => {
    setStopExecutionStatus('STOPPING');
    doStopExecution(execution.ExecutionId);
  };
  
  const doStopExecution = async (executionId) => {
    const { succeeded, error } = await stopExecution(executionId);
    if(succeeded) {
      setStopExecutionStatus('STOPPED');
    } else {
      setStopExecutionStatus('FAILED');
      setStopExecutionMessage(error);
    }
  };
  
  return(
    <Dialog
      className={classes.root}
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {stopExecutionStatus==='STOPPING'?
      <Alert severity="info">
        <AlertTitle>Stopping</AlertTitle>
        Stop execution requested... <strong>please wait!</strong>
      </Alert>
      :stopExecutionStatus==='STOPPED'?
      <Alert severity="success" onClose={onClose}>
        <AlertTitle>Success</AlertTitle>
        Execution was stopped successfully
      </Alert>
      :stopExecutionStatus==='FAILED'?
      <Alert severity="error" onClose={onClose}>
        <AlertTitle>Error</AlertTitle>
        An error occurred stopping execution! {stopExecutionMessage}
      </Alert>
      :
      <React.Fragment>
        <DialogTitle id="alert-dialog-title">
          Stop Execution?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="prompt">
            Are you sure you want to stop the current execution?
          </DialogContentText>
          <Alert severity="warning">
            Stopping will prevent new inputs from being spooled and move the execution to a COMPLETE state, however task deprovisioning is not immediate.
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleStopExecution} color="primary" autoFocus>
            Stop
          </Button>
        </DialogActions>
      </React.Fragment>
      }
    </Dialog>
  );
}

ExecutionActionStop.propTypes = {
  execution: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
};

ExecutionActionStop.defaultProps = {
  open: false,
};